import '../RadioGroup/radioGroup.scss';

import uniqueId from 'lodash/uniqueId';
import { ReactNode, useMemo } from 'react';

import { Radio } from '../Radio/Radio';

type RadioGroupLoadingProps = {
  variant?: 'stacked' | 'stacked-compact' | 'inline';
  labelPlacement?: 'beside' | 'below';
  loadingCount: number;
};

export const RadioGroupLoading = ({
  variant = 'stacked',
  labelPlacement = 'beside',
  loadingCount,
}: RadioGroupLoadingProps): ReactNode => {
  const loadingRadioKeys = useMemo(
    (): string[] =>
      Array.from({ length: loadingCount }, (): string => uniqueId('loading-')),
    [loadingCount],
  );

  return (
    <div className={`radio-group ${variant}`} role="radiogroup">
      {loadingRadioKeys.map(
        (loadingRadioKey): ReactNode => (
          <Radio
            key={loadingRadioKey}
            label=""
            labelPlacement={labelPlacement}
            loading
          />
        ),
      )}
    </div>
  );
};
